<template>
  <nav class="au-legal" :aria-label="STRINGS.aria.labels.legalNavigation">
    <button class="au-legal-nav" @click="emit('navigate', 'about')" data-testid="footer-about-link">
      {{ STRINGS.legal.footer.about }}
    </button>
    <span class="au-legal-sep" aria-hidden="true">&bull;</span>
    <button
      class="au-legal-nav"
      @click="emit('navigate', 'privacy')"
      data-testid="footer-privacy-link"
    >
      {{ STRINGS.legal.footer.privacy }}
    </button>
    <span class="au-legal-sep" aria-hidden="true">&bull;</span>
    <button class="au-legal-nav" @click="emit('navigate', 'terms')" data-testid="footer-terms-link">
      {{ STRINGS.legal.footer.terms }}
    </button>
  </nav>
</template>

<script setup lang="ts">
import type { NavigationState } from '@/types/websocket';
import STRINGS from '@/constants/strings';

const emit = defineEmits<{
  navigate: [target: NavigationState];
}>();
</script>
